import React, { useEffect, useState, useRef } from "react";
import Api from "../services/ApiService";
import { Button, Col, Row } from "react-bootstrap";
import LoginComponent from "../components/login/LoginComponent";
import { useNavigate, useParams } from "react-router-dom";
import QrSplashPage from "./QrSplashPage";
import ImmoComponent from "../components/qr/ImmoComponent";
import { BsChevronLeft } from "react-icons/bs";
import PassForgotForm from "../components/login/PassForgotForm";
import BasicRegForm from "../components/registration/BasicRegForm";
import { useQuery } from "react-query";
import SplashPage from "./SplashPage";

/**
 * HomePage - QR index page
 * 
 * @url "/qr/*"
 * 
 * @components "/components/home".
 * 
 * @returns None
 * 
 * @todo
 *      1. Implement localStorage for InfoModal that shouldn't be show every time.
 *      2. Maybe will be necesery to rename this page to QrPage for better readability.
 *      3. Implement navigation.
 */
const QrPage = () => {

    // If promo video was shown once, we have set an LocalStorage object "promoWasShown" so that we don't show again
    const [loading, setLoading] = useState(true);
    const API = new Api();
    const { qr } = useParams(); // Parameter from url
    const [house, setHouse] = useState(); // JsonObject from backend for house info
    const [anlage, setAnlage] = useState();
    const [partner, setPartner] = useState();
    const [qrError, setQrError] = useState("");

    const [videoDisplay, setVideoDisplay] = useState(require('../hero.mp4'));
    const videoRef = useRef();
    const [view, setView] = useState("login");

    const navigate = useNavigate();

    const { data, error, isLoading } = useQuery(['QR_INFO', qr], () => API.qr_info(qr), { staleTime: Infinity });



    useEffect(() => {
        if (!isLoading) {
            videoRef.current.load();
            videoRef.current.focus();
        }
    }, [videoDisplay])


    // Views
    if (isLoading) return <QrSplashPage />;
    if (error) return <SplashPage error={error} />;
    return (
        <>
            <video
                className="video-section"
                id="background-video"
                autoPlay={videoDisplay.includes('hero') ? true : false}
                muted={videoDisplay.includes('hero') ? true : false}
                controls={videoDisplay.includes('promo') ? true : false}
                ref={videoRef}
                playsInline
            >
                <source src={videoDisplay} type="video/mp4" />
            </video>
            <div className="container-section">
                {view !== 'login' ?
                    <div className="container-section-register">
                        <Col xs="12" className="text-light text-start mb-5">
                            <a onClick={e => { e.preventDefault(); setView('login') }} href="züruck/" className="link-energo-orange">
                                <BsChevronLeft size={40} /> Zurück
                            </a>
                        </Col>
                    </div>
                    : null}


                {
                    view === 'login' ?
                        <div className="container-section-login">
                            <h3 className="text-light text-start"><span className="text-dark title-energo">ENERGO</span> Managementportal</h3>
                            <p className="text-dark text-start">
                                Sie befinden sich in Top {data.data.top.x_topnummer}, {data.data.top.x_gebaeude_address_street}
                            </p>
                            <Row className="mt-3 animate-slide-left">
                                <LoginComponent view={setView} />
                            </Row>
                            <Row className="mt-5">
                                <ul className="list-group list-group-flush mt-3" style={{ background: 'transparent' }}>
                                    <li className="list-group-item" style={{ backgroundColor: 'transparent' }}>
                                        <a onClick={e => { e.preventDefault(); setView('register') }} href="/registrieren/" className="link-energo-light-bold">Kunde werden</a>
                                    </li>
                                    <li className="list-group-item" style={{ backgroundColor: 'transparent' }}>
                                        <a onClick={e => { e.preventDefault(); setVideoDisplay(require('../promo.mp4')) }} href="information/anzeigen" className="link-energo-light-bold">Vorstellungsvideo anzeigen</a>
                                    </li>
                                </ul>
                                <ImmoComponent logo={data.data.hw.image_1920 ? data.data.hw.image_1920 : null} name={data.data.top.x_hausverwaltung_id[1] ?? null} />
                            </Row>
                        </div>

                        : view === 'pass-forgot' ?
                            <div className="container-section-login">
                                <Col xs="12" className="animate-pop text-light text-start">
                                    <h3><span className="text-dark title-energo">ENERGO - </span>Passwort anfordern / vergessen</h3>
                                    <p>Geben Sie bitte Ihre E-Mail-Adresse ein, um Ihr Passwort anzufordern/zurückzusetzen.</p>
                                </Col>
                                <Col xs="12" className="animate-slide-left mt-5">
                                    <PassForgotForm view={setView} />
                                </Col>
                            </div>

                            : view === 'pass-forgot-hv' ?
                                <div className="container-section-login text-light text-start">
                                    <Col xs="12" className="animate-pop">
                                        <h3><span className="text-dark">ENERGO - </span>HV Passwort zurückzusetzen</h3>
                                        <p className="mt-3">
                                            Zurücksetzen / Anfordern des Passworts ist für Hausverwaltungen nicht möglich.
                                            Bitte wenden Sie sich an Ihr Sekretariat, um das Passwort in Erfahrung
                                            zu bringen.
                                        </p>
                                    </Col>
                                </div>

                                : view === 'pass-forgot-done' ?
                                    <div className="container-section-login text-light text-start">
                                        <h3><span className="text-dark">ENERGO - </span>E-Mail versendet</h3>
                                        <p className="mt-3">
                                            Wir haben Ihnen eine E-Mail zukommen lassen!
                                            Folgen Sie bitte den Schritten in der E-Mail.
                                        </p>
                                    </div>

                                    : view === 'register' ?
                                        <div className="container-section-register text-start">
                                            <BasicRegForm qr_code={qr} house={house} anlage={anlage} setView={setView} />
                                        </div>
                                        : view === 'register-done' ?
                                            <div className="container-section-login text-light text-start">
                                                <h4>ENERGO ENERGIEDIENSTLEISTUNGEN GmbH</h4>
                                                <br />
                                                <p>Vielen Dank für die Bekanntgabe Ihrer Daten!</p>
                                                <p>Wir haben Ihnen ein E-Mail gesendet, um Ihre E-Mail-Adresse
                                                    zu verifizieren.</p>
                                                <div className="text-center mt-3">
                                                    <Button variant="warning" onClick={() => setView('login')}>Verstanden</Button>
                                                </div>
                                            </div>
                                            : null
                }
            </div>
        </>
    )
}

export default QrPage;